import schema from './schema'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {
    /*
     * get all recorded Sessions, sorted by date
     */
    get_recorded_sessions_all_goals: ( $models, $registry, $store ) => {
      if ( !$registry.state.res.goal ) {
        return null
      }

      let loaded_goal_id_list = $registry.state.res.goal
        ? Object.keys( $registry.state.res.goal )
        : []

      let recorded_sessions_all_goals =  {}

      loaded_goal_id_list.forEach(goalId => {

        let goal_meta = $registry.state.res.goal[ goalId ].meta;

        /* Check if goal exists and if we have access rights */
        if ( !goal_meta || goal_meta[ '.exists' ] === false || goal_meta[ '.noaccess' ] === true ) {
          console.log("Goal: No access or does not exist", goalId)
          return
        }

        let sessions = $models.taskRecordedSession
          .with({ goalId: goalId })
          .getList()

        if (sessions) {
          let sessionsArray = sessions.itemsAsArray()
          if (sessionsArray.length > 0 ) {
            recorded_sessions_all_goals[ goalId ] = sessionsArray//.push({ goalId, sessions } )
          }
        }
        // recorded_sessions_all_goals = recorded_sessions_all_goals.concat( session.itemsAsArray() )
      })

      // TODO: sort by timestamp
      return recorded_sessions_all_goals
    }
  },
  staticActions: {
  },
  schema:  schema
};
